import * as constants from "./../constants";
import * as logger from './../../logger';
// import { snakeCaseToCamelCase } from "../../utils/utils";

const defaultState = {
  userId: null,
  fullName: null,
  token: null,
  tokenInfo: null,
  userInfo: null,
  isLoggedIn: false,
  isNewUser: false,
  showAddTripOverlay: false,
  toggleChatSupport: false,
  toggleTripCount: false,

  toggleSearch: false,
  showChat: true,
  partyBalance: null,
  vendorBalance: null,
  activeTripCount: null,
  partyLedgerData: [],
  vendorLedgerData: [],
  tripLedgerData: [],
  partyName: null,
  vendorName: null,
  singlePartyLedgerData: [],
  singlePartyPDFReport: {},
  singleVendorPDFReport: {},
  singleVendorLedgerData: [],
  singleTripData: {},
  configs: {},
  allVendors: [],
  allParties: [],
  pnlMonths: [],
  monthlyPNLWise: {},
  addPassbookPhoto: [],
  loginFromWeb: false,
  bankAccounts: [],
  userFuelFavLocations: [],
  userAllFuelLocations: [],
  singleFuelLocation: {},
  driverLedgerData: [],
  cityName: [],
  stateName: [],
  totalCountPartyLedger: "",
  partyMaxPage: null,
  suppliersMaxPage: null,
  driversMaxPage: null,
  singlePartyTripMaxPage: null,
  singleVendorTripsMaxPage: null,
  singleVendorPassbookMaxPage: null,
  userInfoProfile: {},
  paymentConfig: [],
  detailsFromGst: {},
  totalRemainingAmountVendorLedger: "",
  activeTripCountVendorLedger: "",
  allLocations: [],
  allSuggestedOrginLocations: [],
  allSuggestedDestinationLocations: [],
  totalPartyBalance: "",
  toggleSimTrackingPopUp: false,
  multiUserList: [],
  profitLossReport: {},
  profitLossReportPdf: {},
  profitLossReportPdfS3: {},
  supplierLedgerPdfV2: {},
  supplierLedgerPdfS3: {},
  partyLedgerPdfV2: {},
  partyLedgerPdfS3: {},
  supplierTransactionLog: {},
  supplierPaymentData: {},
  supplierTransactHistory: {},
  allTransactionHistory: [],
  supplierPaymentTripSuggestion: {},
  invoiceConfig: {},
  tripsDefaultPageNo: 1,
  tripsDeafultPageSize: 10,
  tripsCurrentPageNo: 1,
  tripsCurrentPageSize: 10,
  backFrom: "",
  shopsData: [],
  shopsEmpty: false,
  sparklineTotalBalance: {},
  singleShopKhataPdf: {}
};
const userInfo = localStorage.getItem("USER_INFO");
const appConfig = localStorage.getItem("USER_APP_CONFIG");

const INITIAL_STATE = {
  showChat: true,
  ...userInfo ? JSON.parse(userInfo) : defaultState,
  ... { configs: appConfig && appConfig != "undefined" ? JSON.parse(appConfig) : {} }
};

export default function userReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case constants.SET_USER_INFO:
      return { ...action.payload };
    case constants.SET_NEW_USER:
      state.isNewUser = action.payload.isNewUser;
      return { ...state };
    case constants.SET_USER_INFO_AFTER_ACCOUNT:
      const user = JSON.parse(localStorage.getItem("USER_INFO"));
      let userCloned = { ...user }
      userCloned.userInfo.city_name = action.payload.data.response.user.city_name;
      userCloned.userInfo.companyName = action.payload.data.response.user.companyName;
      userCloned.userInfo.profileAttributes = action.payload.data.response.user.profileAttributes
      userCloned.userInfo.name = action.payload.data.response.user.name;
      userCloned.userInfo.no_of_vehicles = action.payload.data.response.user.number_of_vehicles;
      userCloned.userInfo.state_name = action.payload.data.response.user.state_name;
      userCloned.userInfo.s3ProfileLink = action.payload.data.response.user.s3ProfileLink;
      userCloned.showAddTripOverlay = action.payload.addTripOverlay;
      userCloned.isNewUser = false;

      state.userInfo.city_name = action.payload.data.response.user.city_name;
      state.userInfo.companyName = action.payload.data.response.user.companyName;
      state.userInfo.profileAttributes = action.payload.data.response.user.profileAttributes
      state.userInfo.name = action.payload.data.response.user.name;
      state.userInfo.no_of_vehicles = action.payload.data.response.user.number_of_vehicles;
      state.userInfo.state_name = action.payload.data.response.user.state_name;
      state.userInfo.s3ProfileLink = action.payload.data.response.user.s3ProfileLink;
      state.showAddTripOverlay = action.payload.addTripOverlay;
      state.isNewUser = false;
      localStorage.setItem("USER_INFO", JSON.stringify(userCloned));
      return { ...state };
    case constants.GET_PARTY_LEDGER_DATA:
      state.totalPartyBalance = action.payload.homeScreenData.partyBalance;
      state.vendorBalance = action.payload.homeScreenData.vendorBalance;
      state.activeTripCount = action.payload.homeScreenData.activeTripCount;
      if (action.payload.merge) {
        state.partyLedgerData = [
          ...state.partyLedgerData,
          ...action.payload.homeScreenData.partyLedgerData
        ]
      } else {
        state.partyLedgerData = action.payload.homeScreenData.partyLedgerData;
      }
      state.totalCountPartyLedger = action.payload.totalCount;
      state.partyMaxPage = action.payload.maxPage;
      return { ...state };
    case constants.GET_VENDOR_LEDGER_DATA:
      if (action.payload.merge) {
        state.vendorLedgerData = [
          ...state.vendorLedgerData,
          ...action.payload.vendorLedgerData
        ]
      } else {
        state.vendorLedgerData = action.payload.vendorLedgerData;
      }
      state.totalRemainingAmountVendorLedger = action.payload.totalRemainingAmountDweb;
      state.activeTripCountVendorLedger = action.payload.activeTripCountDweb;
      state.suppliersMaxPage = action.payload.maxPage;
      return { ...state };
    case constants.GET_TRIP_LEDGER_DATA:
      if (action.payload.merge) {
        state.tripLedgerData = {
          ...action.payload,
          endOfDataFetch: action.payload.tripLedgerData.length < 1 ? true : false,
          tripLedgerData: [
            ...state.tripLedgerData.tripLedgerData,
            ...action.payload.tripLedgerData
          ]
        };
      } else {
        state.tripLedgerData = action.payload;
      }
      state.tripTotalCount = action.payload.totalCount;
      return { ...state };
    case constants.GET_SINGLE_PARTY_LEDGER_DATA:
      state.partyName = action.payload.partyName
      state.partyMobile = action.payload.partyMobile
      if (action.payload.merge) {
        state.singlePartyLedgerData = [
          ...state.singlePartyLedgerData,
          ...action.payload.singlePartyLedgerData
        ]
      } else {
        state.singlePartyLedgerData = action.payload.singlePartyLedgerData
      }
      state.partyBalance = action.payload.partyBalance
      state.dueAmount = action.payload.dueAmount
      state.singlePartyActiveTripCount = action.payload.activeTripCount;
      state.singlePartyTripMaxPage = action.payload.maxPage;
      state.singlePartyOpeningLogs = action.payload.openingLogs;
      return { ...state };
    case constants.GET_SINGLE_PARTY_PDF_REPORT:
      state.singlePartyPDFReport = action.payload.singlePartyPDFReportData
      return { ...state };
    case constants.GET_SINGLE_VENDOR_PDF_REPORT:
      state.singleVendorPDFReport = action.payload.singleVendorPDFReport
      return { ...state };
    case constants.GET_ALL_PARTIES_DATA:
      state.allParties = action.payload.allParties
      return { ...state };
    case constants.GET_ALL_VENDORS_DATA:
      state.allVendors = action.payload.allVendors
      return { ...state };
    case constants.GET_PNL_MONTHS:
      state.pnlMonths = action.payload.pnlMonths
      return { ...state };
    case constants.GET_PNL_MONTHLY_WISE:
      state.monthlyPNLWise = action.payload.monthlyPNLWise
      return { ...state };
    case constants.GET_SINGLE_VENDOR_LEDGER_DATA:
      if (action.payload.merge) {
        state.singleVendorLedgerData = [
          ...state.singleVendorLedgerData,
          ...action.payload.singleVendorLedgerData
        ]
      } else {
        state.singleVendorLedgerData = action.payload.singleVendorLedgerData
      }
      state.singleVendorBalance = action.payload.totalBalance
      state.dueAmount = action.payload.dueAmount
      state.singleVendorActiveTripCount = action.payload.activeTripCount
      state.singleVendorTotalTripCount = action.payload.totalCount
      state.singleVendorPageName = action.payload.vendorName
      state.singleVendorNumber = action.payload.vendorNumber
      state.singleVendorTripsMaxPage = action.payload.singleVendorTripsMaxPage
      return { ...state };
    case constants.UPDATE_VENDOR_NAME:
      state.vendorName = action.payload
      return { ...state };
    case constants.GET_SINGLE_TRIP_DATA:
      state.singleTripData = { ...action.payload }
      return { ...state };
    case constants.RESET_USER_INFO:
      return { ...defaultState };
    case constants.GET_ALL_LOCATIONS:
      state.allLocations = action.payload;
      return { ...state };
    case constants.GET_ALL_SUGGESTED_ORIGIN_LOCATIONS:
      state.allSuggestedOrginLocations = action.payload;
      return { ...state };
    case constants.GET_ALL_SUGGESTED_DESTINATION_LOCATIONS:
      state.allSuggestedDestinationLocations = action.payload;
      return { ...state };
    case constants.ADD_CUSTOM_LOCATION_PROFILE:
      if (action.payload != null) {
        state.allLocations.push({ name: action.payload });
      }
      return { ...state };
    case constants.LOAD_CONFIGS:
      localStorage.setItem("USER_APP_CONFIG", JSON.stringify(action.payload));
      return { ...state, ...{ configs: action.payload } };
    case constants.UPDATE_CHAT_VIEW:
      return { ...state, ...{ showChat: action.payload } };
    case constants.LOAD_CONFIGS_PROFILE:
      localStorage.setItem("USER_PROFILE_CONFIG", JSON.stringify(action.payload));
      return { ...state, ...{ profileConfig: action.payload } };
    case constants.SET_USER_FAV_FUEL_LOCATIONS:
      return { ...state, ...{ userFuelFavLocations: action.payload } };
    case constants.SET_USER_ALL_FUEL_LOCATIONS:
      return { ...state, ...{ userAllFuelLocations: action.payload } };
    case constants.SET_USER_SINGLE_FUEL_LOCATION:
      return { ...state, ...{ singleFuelLocation: action.payload } };
    case constants.ADD_TRIP_POD:
      state.singleTripData.tripPods = action.payload;
      return { ...state };
    case constants.TOGGLE_SEARCH_BAR:
      logger.log("UserReducer", action.payload);
      state.toggleSearch = action.payload;
      return { ...state };
    case constants.ADD_PASSBOOK_PHOTO_UPLOAD:
      var Photo = { ...state, ...{ addPassbookPhoto: action.payload } }
      // if (action.payload != null) {
      //   state.addPassbookPhoto.push(action.payload);
      // }
      return { ...state, ...Photo };
    case constants.BANK_ACCOUNTS:
      var Accounts = { ...state, ...{ bankAccounts: action.payload } }
      logger.log("UserReducer", action.payload)
      return { ...state, ...Accounts }
    case constants.FETCH_ALL_DRIVERS:
      if (action.payload.merge) {
        state.driverLedgerData = {
          ...action.payload,
          balance: state.driverLedgerData.balance + action.payload.balance,
          driverLedgerDataResponse: [
            ...state.driverLedgerData.driverLedgerDataResponse,
            ...action.payload.driverLedgerDataResponse
          ]
        };
      } else {
        return { ...state, ...{ driverLedgerData: action.payload } }
      }
    case constants.GET_ALL_LOCATIONS_FOR_PROFILE:
      var allLocationsForProfile = {
        cityName: [],
      }
      allLocationsForProfile.cityName = action.payload[0];
      return { ...state, ...allLocationsForProfile }
    case constants.GET_ALL_LOCATIONS_STATES:
      var allLocationsForProfile = {
        stateName: []
      }
      allLocationsForProfile.stateName = action.payload;
      return { ...state, ...allLocationsForProfile }
    case constants.GET_USER_DETAILS_FOR_PROFILE:
      let data = action.payload;
      var details = { ...state, ...{ userInfoProfile: data.user } }
      return { ...state, ...details }
    case constants.GET_PAYMENT_CONFIG:
      let reponseData = action.payload;
      var paymentConfig = { ...state, ...{ paymentConfig: reponseData } }
      return { ...state, ...paymentConfig }
    case constants.GET_DETAILS_FROM_GST:
      let responseData = action.payload;
      var detailsFromGst = { ...state, ...{ detailsFromGst: responseData } }
      return { ...state, ...detailsFromGst }
    case constants.TOGGLE_OVERLAY:
      var userInfoItem = JSON.parse(localStorage.getItem("USER_INFO"));
      if (userInfoItem && userInfoItem.hasOwnProperty('showAddTripOverlay')) {
        userInfoItem.showAddTripOverlay = action.payload;
      }
      localStorage.setItem("USER_INFO", JSON.stringify(userInfoItem));
      return { ...state, ...{ showAddTripOverlay: action.payload } }
    case constants.TOGGLE_CHAT_SUPPORT:
      return { ...state, ...{ toggleChatSupport: action.payload } }
    case constants.GET_MULTI_USER_LIST:
      return { ...state, ...{ multiUserList: action.payload } }
    case constants.REFRESH_TOKEN:
      let localStorageUserInfo = JSON.parse(localStorage.getItem("USER_INFO"));

      // *************** Setting new accessToken to localStorage. *************
      if (localStorageUserInfo && localStorageUserInfo.tokenInfo && localStorageUserInfo.tokenInfo.accessToken) {
        localStorageUserInfo.tokenInfo.accessToken = action && action.payload && action.payload.accessToken ? action.payload.accessToken : localStorageUserInfo.tokenInfo.accessToken;
        localStorage.setItem("USER_INFO", JSON.stringify(localStorageUserInfo));
      }

      if (state && state.tokenInfo && state.tokenInfo.accessToken) {
        state.tokenInfo.accessToken = action && action.payload && action.payload.accessToken ? action.payload.accessToken : state.tokenInfo.accessToken
      }
    case constants.GET_PROFIT_LOSS_REPORT:
      return { ...state, ...{ profitLossReport: action.payload } }
    case constants.GET_PROFIT_LOSS_PDF_V2:
      return { ...state, ...{ profitLossReportPdf: action.payload } }
    case constants.GET_PROFIT_LOSS_PDF_DOWNLOAD_V2:
      return { ...state, ...{ profitLossReportPdfS3: action.payload } }
    case constants.GET_SUPPLIER_LEDGER_PDF_V2:
      return { ...state, ...{ supplierLedgerPdfV2: action.payload } }
    case constants.GET_SUPPLIER_LEDGER_PDF_DOWNLOAD_V2:
      return { ...state, ...{ supplierLedgerPdfS3: action.payload } }
    case constants.GET_PARTY_LEDGER_PDF_V2:
      return { ...state, ...{ partyLedgerPdfV2: action.payload } }
    case constants.GET_PARTY_LEDGER_PDF_DOWNLOAD_V2:
      return { ...state, ...{ partyLedgerPdfS3: action.payload } }
    case constants.SUPPLIER_TRANSACTION_LOG:
      state.singleVendorPassbookMaxPage = action.payload.maxPage
      if (action.payload.merge) {
        return {
          ...state, ...{
            supplierTransactionLog: [
              ...state.supplierTransactionLog,
              ...action.payload.transactions
            ]
          }
        }
      } else {
        return { ...state, ...{ supplierTransactionLog: action.payload.transactions } }
      }
    case constants.GET_SUPPLIER_PAYMENT_DATA:
      return { ...state, ...{ supplierPaymentData: action.payload } }
    case constants.GET_SUPPLIER_TRANSACT_HISTORY:
      return { ...state, ...{ supplierTransactHistory: action.payload } }
    case constants.TRANSACTION_HISTORY:
      if (action.payload.merge) {
        state.allTransactionHistory = {
          ...action.payload,
          transactions: [
            ...state.allTransactionHistory.transactions,
            ...action.payload.transactions
          ]
        };
      } else {
        return { ...state, ...{ allTransactionHistory: action.payload } }
      }
    case constants.GET_TRIP_SUGGESTION_SUPPLIER:
      return { ...state, ...{ supplierPaymentTripSuggestion: action.payload } }
    case constants.GET_SHOP_KHATA_DATA:
      state.shopsEmpty = action.payload.shopsData.length > 0 ? false : true;
      if (action.payload.merge) {
        state.shopsData = [
          ...state.shopsData,
          ...action.payload.shopsData
        ]
      } else {
        return { ...state, ...{ shopsData: action.payload.shopsData } }
      }
    case constants.UPDATE_BACK_BUTTON:
      return {
        ...state, ...{
          backFrom: action.payload
        }
      }
    case constants.GET_ONLINE_PAYMENT_CONFIG:
      return { ...state, ...{ onlinePaymentConfig: action.payload } }
    case constants.GET_INVOICE_CONFIG:
      return { ...state, ...{ invoiceConfig: action.payload } }
    case constants.GET_SPARKLINE_DATA:
      return { ...state, ...{ sparklineTotalBalance: action.payload } }
    case constants.GET_SINGLE_SHOP_KHATA_PDF:
      return { ...state, ...{ singleShopKhataPdf: action.payload } }
    case constants.GET_TRIP_LEDGER_DATA_V2:
      if (action.payload.merge) {
        state.tripLedgerDataV2 = {
          ...action.payload,
          endOfDataFetch: action.payload.tripLedgerData.length < 1 ? true : false,
          tripLedgerData: [
            ...state.tripLedgerDataV2.tripLedgerData,
            ...action.payload.tripLedgerData
          ]
        };
      } else {
        state.tripLedgerDataV2 = action.payload;
      }
      state.tripTotalCount = action.payload.totalCount;
      return { ...state };
    case constants.GET_FILTERED_CONFIG:

      const configData = action.payload
      const config = {}

      if (configData) {
        if ('fuel_card' in configData) {
          state["fuelCardConfig"] = configData["fuel_card"]
        }

        if ('online_payments_config' in configData) {
          state["onlinePaymentConfig"] = configData["online_payments_config"]
          config['online_payments_config'] = configData["online_payments_config"]
        }

        if ('dwebSearchBebounceMs' in configData) {
          config['dwebSearchBebounceMs'] = configData["dwebSearchBebounceMs"]
        }

        if ('panRegex' in configData) {
          config['panRegex'] = configData["panRegex"]
        }

        if ('gstRegex' in configData) {
          config['gstRegex'] = configData["gstRegex"]
        }

        if ('pincodeRegex' in configData) {
          config['pincodeRegex'] = configData["pincodeRegex"]
        }

        if ('GST_STATE_LIST' in configData) {
          config['GST_STATE_LIST'] = configData["GST_STATE_LIST"]
        }

        if ('subscription' in configData) {
          config['subscription'] = configData["subscription"]
        }

        if ('coming_soon' in configData) {
          config['coming_soon'] = configData["coming_soon"]
        }

        if ('VehicleRegex' in configData) {
          config['VehicleRegex'] = configData["VehicleRegex"]
        }

        if ('event_tracking' in configData) {
          config["eventTracking"] = configData["event_tracking"]
        }

      }

      state.configs = config

      localStorage.setItem("USER_APP_CONFIG", JSON.stringify(configData))

      return { ...state }

    default:
      return state;
  }
}
